export default __webpack_public_path__ + "static/media/24-5-ZacBrownBand-NewLogo.5435f4fb.jpg";